import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { VbUpcomingPayment } from '../../../../../../models/transactions/vb-upcoming-payment';
import { TrackByUtils } from '../../../../../../utils/track-by-utils';

const LUMP_SUM_DATE_FORMAT = 'longDate';
const RECURRING_DATE_FORMAT = 'MMMM yyyy';

/** A lump sum payment happens on a specific day, so its date must include the day. */
function resolveDateFormat(paymentType: string): string {
  return paymentType?.toLowerCase().includes('lump sum') ? LUMP_SUM_DATE_FORMAT : RECURRING_DATE_FORMAT;
}

interface UpcomingPaymentRow {
  paymentType: string;
  date: string;
  amount: number;
  dateFormat: string;
}

@Component({
  selector: 'app-vb-payment-change-upcoming-payments-modal',
  templateUrl: './vb-payment-change-upcoming-payments-modal.component.html',
  styleUrls: ['./vb-payment-change-upcoming-payments-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbPaymentChangeUpcomingPaymentsModalComponent {
  private activeModal = inject(NgbActiveModal);

  public upcomingPayments: UpcomingPaymentRow[] = [];

  public setUpcomingPayments(upcomingPayments: VbUpcomingPayment[]): void {
    this.upcomingPayments = upcomingPayments.map(payment => ({
      paymentType: payment.paymentType,
      date: payment.date,
      amount: payment.amount,
      dateFormat: resolveDateFormat(payment.paymentType)
    }));
  }

  public close(): void {
    this.activeModal.close();
  }

  protected readonly trackByIndex = TrackByUtils.trackByIndex;
}
